function getRandomInt (min, max) {
    return Math.floor(Math.random() * (max - min)) + min
}

export function getRandomFirstName () {
    const nameList = [
        'ปัทมา',
        'อุทัย',
        'กิตติทัต',
        'กนกวรรณ',
        'พงษธร',
        'สัญญา',
        'กิตติพันธ์',
        'สมจิตร',
        'สมศรี',
        'สมชาย'
    ]

    return nameList[getRandomInt(0, nameList.length)]
}

export function getRandomLastName () {
    const lastNameList = [
        'ใจเย็น',
        'สง่าจันทร์',
        'พิบูลพงษ์',
        'ทอแสง',
        'แสงสว่าง',
        'กระจ่างวงศ์',
        'สุนทรีย์',
        'มีสกุล',
        'เข็มแข็ง',
        'อ่อนโยน'
    ]
    return lastNameList[getRandomInt(0, lastNameList.length)]
}

export function getBooking (page) {
    const bookingList = []

    const mockObj = {
        itemAmount: 5,
        total: 4200
    }

    const mockTicketObj = {
        ticketId: 'TK001',
        id: '001',
        productName: 'Adult Pass',
        price: 780,
        amount: 2,
        total: 5600
    }

    for (let i = 0; i < 100; i++) {
        const ticketList = []
        for (let j = 0; j < 1; j++) {
            ticketList.push({
                ...mockTicketObj,
                id: `${mockTicketObj.id}-${j}`
            })
        }
        bookingList.push({
            id: i,
            bookingNo: `BO-${i}`,
            ticketList,
            ...mockObj,
            bookingDate: new Date(`2021-12-${getRandomInt(1, 20)}`),
            travelDate: new Date(`2021-10-${getRandomInt(1, 20)}`),
            customer: {
                firstName: getRandomFirstName(),
                lastName: getRandomLastName()
            }
        })
    }

    return bookingList.slice((page - 1) * 50)
}

export function getAgentBooking (page) {
    const bookingList = []

    const mockObj = {
        quantity: 2,
        total: 520
    }

    for (let i = 0; i < 100; i++) {
        bookingList.push({
            id: i,
            bookingNo: `SO-${i}`,
            ...mockObj,
            bookingDate: new Date(`2021-12-${getRandomInt(1, 20)}`),
            travelDate: new Date(`2021-10-${getRandomInt(1, 20)}`),
            saleAccount: `${getRandomFirstName()} ${getRandomLastName()}`
        })
    }

    return bookingList.slice((page - 1) * 50)
}

export function getCustomer (page) {
    const customerList = []

    const mockObj = {
        email: 'ptm_1234@gmail.com',
        nationality: 'Thai',
        lastestLoginDate: new Date(),
        registerDate: new Date(),
        registerBy: 'abc_123@gmail.com',
        status: 'active'
    }

    const mockTicketObj = {
        ticketId: 'TK001',
        id: '001',
        productName: 'Adult Pass',
        price: 780,
        amount: 2,
        total: 5600
    }

    for (let i = 0; i < 100; i++) {
        const bookingList = []
        for (let j = 0; j < 5; j++) {
            const ticketList = []
            for (let k = 0; k < getRandomInt(1, 4); k++) {
                ticketList.push({
                    ...mockTicketObj,
                    id: `${mockTicketObj.id}-${k}`
                })
            }
            bookingList.push({
                bookingNo: `BO-${i}${j}`,
                bookingDate: new Date(`2021-10-${getRandomInt(1, 25)}`),
                travelDate: new Date(`2021-11-${getRandomInt(1, 25)}`),
                itemAmount: getRandomInt(1, 5),
                total: getRandomInt(150, 4200),
                ticketList
            })
        }

        const firstName = getRandomFirstName()
        const lastName = getRandomLastName()

        customerList.push({
            id: `USER-${i}`,
            ...mockObj,
            bookingList: bookingList.map(booking => ({ ...booking, customer: { firstName, lastName } })),
            firstName: firstName,
            lastName: lastName
        })
    }

    return customerList.slice((page - 1) * 50)
}

export function getPocket () {
    const pocketList = []
    for (let i = 0; i < 4; i++) {
        pocketList.push({
            id: `PK-${i}`,
            customer: {
                id: 'AM0001',
                firstName: getRandomFirstName(),
                lastName: getRandomLastName(),
                email: 'abc_def@gmail.com',
                nationality: 'Thai',
                lastestLoginDate: new Date(),
                registerDate: new Date(),
                registerBy: 'abc_123@gmail.com',
                status: 'active'
            },
            transactions: [
                {
                    refNo: '123456',
                    date: new Date(),
                    detail: 'Top-up Coin',
                    receive: 1000,
                    pay: null
                },
                {
                    refNo: '123457',
                    date: new Date(),
                    detail: 'Snack Bar',
                    receive: null,
                    pay: 120
                }
            ],
            activationDate: new Date(`2021-10-${getRandomInt(1, 24)}`),
            currentBalance: getRandomInt(10, 1000)
        })
    }

    return pocketList
}

export function getWristband () {
    const wristbands = []

    for (let i = 0; i < 4; i++) {
        wristbands.push({
            id: `WS-${i}`,
            transactions: [
                {
                    refNo: '123456',
                    date: new Date(),
                    detail: 'Top-up Coin',
                    receive: 1000,
                    pay: null
                },
                {
                    refNo: '123457',
                    date: new Date(),
                    detail: 'Snack Bar',
                    receive: null,
                    pay: 120
                }
            ],
            wristbandName: 'Lilly',
            activationDate: new Date(`2021-10-${getRandomInt(1, 24)}`),
            currentBalance: getRandomInt(10, 1000)
        })
    }

    return wristbands
}

export function getCustomerGroupList () {
    const customerGroups = [
        {
            name: 'Pi R Sqaure',
            companyAddress: 'ชั้น 24 อาคารชำนาญเพ็ญชาติ พระราม 9'
        },
        {
            name: 'Pi R',
            companyAddress: 'ชั้น 24 อาคารชำนาญเพ็ญชาติ พระราม 9'
        },
        {
            name: 'Proud Group',
            companyAddress: 'ชั้น 24 อาคารชำนาญเพ็ญชาติ พระราม 9'
        },
        {
            name: 'Andamanda',
            companyAddress: 'ชั้น 24 อาคารชำนาญเพ็ญชาติ พระราม 9'
        }
    ]

    for (let i = 0; i < customerGroups.length; i++) {
        customerGroups[i] = {
            ...customerGroups[i],
            id: `#000${i}`,
            addressInfo: {
                info: 'ชั้น 24 อาคารชำนาญเพ็ญชาติ พระราม 9',
                province: 'กรุงเทพมหานคร',
                phone: `0${getRandomInt(10, 100)}-${getRandomInt(100, 1000)}-${getRandomInt(100, 1000)}`,
                taxNumber: `${getRandomInt(1000000, 100000000)}`
            },
            isUseCompanyAddress: true,
            deliveryAddress: {
                info: '',
                province: ''
            },
            contact: {
                name: `${getRandomFirstName()} ${getRandomLastName()}`,
                phone: `0${getRandomInt(10, 100)}-${getRandomInt(100, 1000)}-${getRandomInt(100, 1000)}`
            },
            lastUpdate: new Date(`2021-10-${getRandomInt(1, 24)}`),
            updatedBy: 'Administrator'
        }
    }

    return customerGroups
}

export function getEvents () {
    const events = []

    const customerNameMapDict = {
        0: 'Pi R Sqaure',
        1: 'Pi R',
        2: 'Proud Group',
        3: 'Andamanda'
    }

    const teamTypeMapDict = {
        0: 'random',
        1: 'custom'
    }

    const eventStatusMapDict = {
        0: 'active',
        1: 'inactive'
    }

    for (let i = 0; i < 6; i++) {
        events.push({
            id: `E-00${i}`,
            customer: customerNameMapDict[getRandomInt(0, 4)],
            startDate: new Date(`2021-11-${getRandomInt(1, 25)}`),
            participantAmount: getRandomInt(1, 31),
            participantMax: 30,
            teamAmount: getRandomInt(1, 6),
            teamType: teamTypeMapDict[getRandomInt(0, 2)],
            status: eventStatusMapDict[getRandomInt(0, 2)],
            code: `${getRandomInt(0, 100)}`,
            lastUpdateDate: new Date(),
            updatedBy: 'Administrator'
        })
    }
    return events
}

export function getParticipants () {
    const participants = [
        {
            customer: {
                name: 'Pi R Sqaure'
            }
        },
        {
            customer: {
                name: 'Pi R'
            }
        },
        {
            customer: {
                name: 'Proud Group'
            }
        },
        {
            customer: {
                name: 'Andamanda'
            }
        }
    ]

    for (let i = 0; i < participants.length; i++) {
        participants[i] = {
            ...participants[i],
            contact: {
                name: `${getRandomFirstName()} ${getRandomLastName()}`,
                phone: `0${getRandomInt(10, 100)}-${getRandomInt(100, 1000)}-${getRandomInt(100, 1000)}`
            },
            registrationDate: new Date(`2021-11-${getRandomInt(1, 25)}`)
        }
    }
    return participants
}

export function getStaffs () {
    const staffs = []
    const roleMapDict = {
        0: 'Staff',
        1: 'Administrator'
    }

    for (let i = 0; i < 8; i++) {
        staffs.push({
            id: `#100${i}`,
            name: `${getRandomFirstName()} ${getRandomLastName()}`,
            phone: `0${getRandomInt(10, 100)}-${getRandomInt(100, 1000)}-${getRandomInt(100, 1000)}`,
            username: `test${i}`,
            role: roleMapDict[getRandomInt(0, 2)],
            lastUpdateDate: new Date(),
            updatedBy: 'Administrator'
        })
    }
    return staffs
}

export function getIBeaconMessages () {
    const messages = [
        {
            id: 'PR00001',
            topic: 'Happiness Splash Promotion',
            dates: [
                new Date('2021-10-12'),
                new Date('2021-10-25')
            ]
        }
    ]

    return messages
}

export function getIBeaconList () {
    const ibeacons = []
    const message = {
        0: 'Happiness Splash Promotion',
        1: 'Happiness Splash',
        2: ''
    }

    for (let i = 0; i < 8; i++) {
        ibeacons.push({
            no: i + 1,
            macAddress: `ACB${getRandomInt(100000, 1000000)}EWE`,
            name: `KBeacon_000${i}`,
            message: message[getRandomInt(0, 3)]
        })
    }
    return ibeacons
}

export function getSaleAgentRequests () {
    return [
        {
            id: 1,
            requestDate: new Date(`2021-11-${getRandomInt(1, 25)}`),
            type: 'sales-agent',
            agentType: 'Tour Agency',
            name: `${getRandomFirstName()} ${getRandomLastName()}`,
            passportId: `${getRandomInt(Math.pow(10, 11), Math.pow(10, 12))}`,
            carId: '1 ACB',
            company: 'บริษัท ภูเก็ตโลคอลทัวร์ จำกัด',
            phone: `0${getRandomInt(10, 100)}-${getRandomInt(100, 1000)}-${getRandomInt(100, 1000)}`,
            email: 'test@email.com',
            cardImage: '/assets/temp-card.jpg',
            approveStatus: 'waiting'
        },
        {
            id: 2,
            requestDate: new Date(`2021-11-${getRandomInt(1, 25)}`),
            type: 'sales-agent',
            agentType: 'Taxi / Van',
            name: `${getRandomFirstName()} ${getRandomLastName()}`,
            passportId: `${getRandomInt(Math.pow(10, 11), Math.pow(10, 12))}`,
            carId: '2 ACB',
            company: '-',
            phone: `0${getRandomInt(10, 100)}-${getRandomInt(100, 1000)}-${getRandomInt(100, 1000)}`,
            email: 'test@email.com',
            cardImage: '/assets/temp-card.jpg',
            approveStatus: 'reject'
        },
        {
            id: 3,
            requestDate: new Date(`2021-11-${getRandomInt(1, 25)}`),
            type: 'Staff',
            agentType: '',
            name: `${getRandomFirstName()} ${getRandomLastName()}`,
            passportId: `${getRandomInt(Math.pow(10, 11), Math.pow(10, 12))}`,
            carId: '3 ACB',
            company: 'Andamanda Staff',
            phone: `0${getRandomInt(10, 100)}-${getRandomInt(100, 1000)}-${getRandomInt(100, 1000)}`,
            email: 'test@email.com',
            cardImage: '/assets/temp-card.jpg',
            approveStatus: 'waiting'
        }
    ]
}

export function getAndamandaStaffs () {
    return [
        {
            id: 1,
            requestDate: new Date(`2021-11-${getRandomInt(1, 25)}`),
            type: 'Staff',
            agentType: '-',
            name: `${getRandomFirstName()} ${getRandomLastName()}`,
            passportId: `${getRandomInt(Math.pow(10, 11), Math.pow(10, 12))}`,
            carId: '1 ACB',
            company: 'Andamanda Staff',
            phone: `0${getRandomInt(10, 100)}-${getRandomInt(100, 1000)}-${getRandomInt(100, 1000)}`,
            email: 'test@email.com',
            cardImage: '/assets/temp-card.jpg',
            approveStatus: 'approve',
            status: 'inactive'
        },
        {
            id: 2,
            requestDate: new Date(`2021-11-${getRandomInt(1, 25)}`),
            type: 'Staff',
            agentType: '-',
            name: `${getRandomFirstName()} ${getRandomLastName()}`,
            passportId: `${getRandomInt(Math.pow(10, 11), Math.pow(10, 12))}`,
            carId: '2 ACB',
            company: 'Andamanda Staff',
            phone: `0${getRandomInt(10, 100)}-${getRandomInt(100, 1000)}-${getRandomInt(100, 1000)}`,
            email: 'test@email.com',
            cardImage: '/assets/temp-card.jpg',
            approveStatus: 'approve',
            status: 'active'
        }
    ]
}

export function getSaleAgents () {
    return [
        {
            id: 1234556,
            requestDate: new Date(`2021-11-${getRandomInt(1, 25)}`),
            type: 'sales-agent',
            agentType: 'Tour Agency',
            name: `${getRandomFirstName()} ${getRandomLastName()}`,
            passportId: `${getRandomInt(Math.pow(10, 11), Math.pow(10, 12))}`,
            carId: '1 ACB',
            company: 'บริษัท ภูเก็ตโลคอลทัวร์ จำกัด',
            phone: `0${getRandomInt(10, 100)}-${getRandomInt(100, 1000)}-${getRandomInt(100, 1000)}`,
            email: 'test@email.com',
            cardImage: '/assets/temp-card.jpg',
            approveStatus: 'approve',
            ticketAmount: 25,
            status: 'active',
            saleHistory: [
                {
                    bookingNo: '123456',
                    staff: `${getRandomFirstName()} ${getRandomLastName()}`,
                    touristAmount: 2,
                    total: 520
                },
                {
                    bookingNo: '123457',
                    staff: `${getRandomFirstName()} ${getRandomLastName()}`,
                    touristAmount: 2,
                    total: 520
                }
            ]
        },
        {
            id: 1255672,
            requestDate: new Date(`2021-11-${getRandomInt(1, 25)}`),
            type: 'sales-agent',
            agentType: 'Taxi / Van',
            name: `${getRandomFirstName()} ${getRandomLastName()}`,
            passportId: `${getRandomInt(Math.pow(10, 11), Math.pow(10, 12))}`,
            carId: '2 ACB',
            company: '-',
            phone: `0${getRandomInt(10, 100)}-${getRandomInt(100, 1000)}-${getRandomInt(100, 1000)}`,
            email: 'test@email.com',
            cardImage: '/assets/temp-card.jpg',
            approveStatus: 'approve',
            ticketAmount: 20,
            status: 'active',
            saleHistory: [
                {
                    bookingNo: '123458',
                    staff: `${getRandomFirstName()} ${getRandomLastName()}`,
                    touristAmount: 2,
                    total: 520
                },
                {
                    bookingNo: '123459',
                    staff: `${getRandomFirstName()} ${getRandomLastName()}`,
                    touristAmount: 2,
                    total: 520
                }
            ]
        }
    ]
}
